import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import {SafetyprogramComponent} from './safetyprogram/safetyprogram.component';
import {SafetytrainingComponent} from './safetytraining/safetytraining.component';
import {SafetyinspectionsComponent} from './safetyinspections/safetyinspections.component';
import {TermsComponent} from './terms/terms.component';
import {OurcompanyComponent} from './ourcompany/ourcompany.component';
import {OurteamComponent} from './ourteam/ourteam.component';
import {ContactComponent} from './contact/contact.component';
import {BlogComponent} from './blog/blog.component';
import {OurteamdetailComponent} from './ourteamdetail/ourteamdetail.component';
import {BlogdetailComponent} from './blogdetail/blogdetail.component';
import {ColoradoComponent} from './colorado/colorado.component';
import {ArizonaComponent} from './arizona/arizona.component';
import {TexasComponent} from './texas/texas.component';
import {OshaprocedureComponent} from './oshaprocedure/oshaprocedure.component';
import { DmsComponent } from './dms/dms.component';
import { BlogquestionComponent } from './blogquestion/blogquestion.component';
import { FaqComponent } from './faq/faq.component';
import { SafetyvideosComponent } from './safetyvideos/safetyvideos.component';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { OthertrainingsComponent } from './othertrainings/othertrainings.component';
import { NsprogramComponent } from './nsprogram/nsprogram.component';
import { RsprogramComponent } from './rsprogram/rsprogram.component';
import { DmsfaqComponent } from './dmsfaq/dmsfaq.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { OshaComponent } from './osha/osha.component';
import { OnsitetrainingComponent } from './onsitetraining/onsitetraining.component';
import { FloridaComponent } from './florida/florida.component';
import { LivetrainingsComponent } from './livetrainings/livetrainings.component';
import { TrainingloginComponent } from './traininglogin/traininglogin.component';
import { TrainingentryComponent } from './trainingentry/trainingentry.component';
import { CareersComponent } from './careers/careers.component';
import { MeetingloginComponent } from './meetinglogin/meetinglogin.component';
import { MeetingentryComponent } from './meetingentry/meetingentry.component';
import { HelpfileComponent } from './helpfile/helpfile.component';
import { SfiteamComponent } from './sfiteam/sfiteam.component';
import { NorthcarolinaComponent } from './northcarolina/northcarolina.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { EulaComponent } from './eula/eula.component';

const routes: Routes = [
  { 
    path: '', 
    component: HomeComponent
  },
  {
    path: 'ourcompany',
    component:OurcompanyComponent
  },
  {
    path: 'ourteam',
    component:OurteamComponent,    
  },  
  {
    path:'teamdetail/:id',
    component:OurteamdetailComponent
  },
  {
    path: 'safetyprogram',
    component:SafetyprogramComponent
  },
  {
    path: 'safetytraining',
    component:SafetytrainingComponent
  },
  {
    path: 'safetyinspection',
    component:SafetyinspectionsComponent
  },
  {
    path: 'livetrainings',
    component:LivetrainingsComponent
  },
  {
    path:'traininglogin',
    component:TrainingloginComponent
  },
  {
    path:'trainingentry',
    component:TrainingentryComponent
  },
  {
    path:'meetinglogin',
    component:MeetingloginComponent
  },
  {
    path:'meetingentry',
    component:MeetingentryComponent
  },
  {
    path: 'dms',
    component:DmsComponent
  },
  {
    path:'colorado',
    component:ColoradoComponent,
  },
  {
    path:'florida',
    component:FloridaComponent,
  },
  {
    path:'texas',
    component:TexasComponent,
  },
  {
    path:'arizona',
    component:ArizonaComponent,
  },
  {
    path:'nc',
    component:NorthcarolinaComponent,
  },
  {
    path: 'terms-of-service',
    component:TermsComponent
  },
  { 
    path: 'contact', 
    component: ContactComponent 
  },
  { 
    path: 'careers', 
    component: CareersComponent
  },
  { 
    path: 'privacy', 
    component: PrivacyComponent
  },
  { 
    path: 'eula', 
    component: EulaComponent
  },
  { 
    path: 'blog', 
    component: BlogComponent
  },
  {
    path:'blogdetail/:id',
    component:BlogdetailComponent
  },
  {
    path:'blogquestion/:id',
    component:BlogquestionComponent
  },  
  {
    path:'oshaprocedures',
    component:OshaprocedureComponent
  },   
  {
    path:'faq',
    component:FaqComponent
  },
  {
    path:'sv',
    component:SafetyvideosComponent
  },
  {
    path:'newsletter',
    component:NewsletterComponent
  },
  {
    path:'ot',
    component:OthertrainingsComponent
  },
  {
    path:'nsp',
    component:NsprogramComponent
  },
  {
    path:'rsp',
    component:RsprogramComponent
  },
  {
    path:'dmsfaq',
    component:DmsfaqComponent
  },
  {
    path:'onsitetraining',
    component:OnsitetrainingComponent
  },
  {
    path:'osha',
    component:OshaComponent
  },
  {
    path:'helpfile',
    component:HelpfileComponent
  },
  {
    path:'sfiteam',
    component:SfiteamComponent
  },
  { path: '**', component: NotfoundComponent }
];

console.log(routes);
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
